<template>
  <fieldset>
    <legend>
      <span class="pull-left">{{ $t("form.working_hours.legend") }}</span>
      <!-- <a class="fa fa-question-circle" @click="displayModal($event, 0)" /> -->
      <a
        class="pull-right"
        ref="collapseLink"
        data-toggle="collapse"
        href="#collapse_working_hours"
        role="button"
        aria-expanded="true"
        aria-controls="collapse_working_hours"
      >
        <span class="fa fa-angle-up"></span>
        <span class="fa fa-angle-down"></span>
      </a>
    </legend>

    <modal v-show="showModal" @close="showModal = false">
      <h2 slot="modal-header">{{ $t("form.working_hours.legend") }}</h2>
      <div slot="modal-body">
        {{ $t("form.working_hours.modal") }}
      </div>
    </modal>

    <div
      class="collapse show"
      id="collapse_working_hours"
      ref="collapseElement"
    >
      <div v-if="showOptionA">
        <label>
          <strong>{{ $t("form.working_hours.option_a.heading") }}</strong>
        </label>

        <div v-if="!options.A_otherSelected">
          <label for="option_a_full_time">
            <input
              type="checkbox"
              id="option_a_full_time"
              v-model="options.A_fullTimeSelected"
            />
            {{ $t("form.working_hours.option_a.full_time.label") }}
          </label>
        </div>

        <label for="guide_appendix_a" v-if="options.A_fullTimeSelected">
          <input
            type="checkbox"
            name="guide_appendix_a"
            id="guide_appendix_a"
            @click="showModal = true"
            v-model="options.A_guideInAppendix"
          />
          {{ $t("form.working_hours.option_a.appendix") }}
        </label>

        <div v-if="!options.A_fullTimeSelected">
          <label for="option_a_other">
            <input
              type="checkbox"
              id="option_a_other"
              v-model="options.A_otherSelected"
            />
            {{ $t("form.working_hours.option_a.other.label") }}
          </label>
        </div>
      </div>

      <div v-if="options.A_otherSelected">
        <div class="form-group">
          <label for="option_a_other_amount">{{
            $t("form.working_hours.option_a.other.amount.label")
          }}</label>
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              id="option_a_other_amount"
              :placeholder="
                $t('form.working_hours.option_a.other.amount.placeholder')
              "
              v-model="options.A_amount"
              @invalid="
                expandContent($refs.collapseLink, $refs.collapseElement)
              "
              required
            />
            <!-- <div class="invalid-feedback">
                <invalid-cross></invalid-cross>
                <span>{{ $t('form.validation_error_message') }}</span>
              </div> -->
          </div>
        </div>
      </div>

      <div v-if="showOptionB">
        <label>
          <strong>{{ $t("form.working_hours.option_b.heading") }}</strong>
        </label>

        <div>
          <label for="option_b">
            <input type="checkbox" id="option_b" v-model="options.B_selected" />
            {{ $t("form.working_hours.option_b.label") }}
          </label>
        </div>
        <label for="guide_appendix_b" v-if="options.B_selected">
          <input
            type="checkbox"
            name="guide_appendix_b"
            id="guide_appendix_b"
            @click="showModal = true"
            v-model="options.B_guideInAppendix"
          />
          Se vedhæftede arbejdsplan, som er en del af kontrakten
        </label>
      </div>

      <div v-if="showOptionC">
        <label>
          <strong>{{ $t("form.working_hours.option_c.heading") }}</strong>
        </label>

        <div>
          <label for="option_c">
            <input type="checkbox" id="option_c" v-model="options.C_selected" />
            {{ $t("form.working_hours.option_c.label") }}
          </label>
        </div>
      </div>

      <div v-if="options.A_fullTimeSelected || options.A_otherSelected">
        <working-hours-input-a v-if="!options.A_guideInAppendix" />
      </div>

      <div v-if="options.B_selected">
        <working-hours-input-b v-if="!options.B_guideInAppendix" />
      </div>

      <div v-if="options.C_selected">
        <working-hours-input-c />
      </div>
    </div>
  </fieldset>
</template>

<script>
import workingHoursInputA from "./WorkingHoursInputA";
import workingHoursInputB from "./WorkingHoursInputB";
import workingHoursInputC from "./WorkingHoursInputC";
export default {
  components: {
    workingHoursInputA,
    workingHoursInputB,
    workingHoursInputC,
  },
  data() {
    return {
      showModal: false,
      options: {
        A_guideInAppendix: false,
        A_fullTimeSelected: false,
        A_otherSelected: false,
        A_amount: "",
        B_selected: false,
        B_guideInAppendix: false,
        C_selected: false,
      },
    };
  },
  computed: {
    showOptionA() {
      return (
        this.options.B_selected === false && this.options.C_selected === false
      );
    },
    showOptionB() {
      return (
        this.options.A_fullTimeSelected === false &&
        this.options.A_otherSelected === false &&
        this.options.C_selected === false
      );
    },
    showOptionC() {
      return (
        this.options.A_fullTimeSelected === false &&
        this.options.A_otherSelected === false &&
        this.options.B_selected === false
      );
    },
  },
  watch: {
    options: {
      handler() {
        this.$store.commit("updateWorkingHoursOptions", this.options);
      },
      deep: true,
    },
  },
};
</script>
